/**
 * Format reference number
 *
 * @param {number|string} clientId
 * @returns Formatted Client ID with last 4 digits separated
 */
function formatRefNumber(clientId) {
    if (!Number.isInteger(clientId) && typeof clientId !== "string") {
        return "";
    }
    const processedId = `${clientId}`;
    const first = processedId.slice(0, -4);
    const last = processedId.slice(-4);
    return `${first} / ${last}`;
}

/**
 * Format date
 *
 * @param {string} rawDate
 * @returns formatted date
 */
function formatDate(rawDate) {
    const date = new Date(rawDate);
    const formattedDate = `${date.getDate()}/${
        date.getMonth() + 1
    }/${date.getFullYear()}`;
    return formattedDate;
}

/**
 * Clear active class from array of elements
 *
 * @param {array} elements
 */
function clearActive(elements) {
    elements.forEach((el) => {
        el.classList.remove("active");
    });
}

/**
 * Toggle font awesome class
 *
 * @param {HTML element} element
 * @param {string} direction
 */
function toggleArrow(element, direction) {
    if (direction === "up") {
        element.classList.remove("fa-arrow-down");
        element.classList.add("fa-arrow-up");
    } else {
        element.classList.remove("fa-arrow-up");
        element.classList.add("fa-arrow-down");
    }
}

export { formatRefNumber, formatDate, clearActive, toggleArrow };
